import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';

class PrototypeLink extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            locale: props.locale,
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }

    render() {
        return (
            <div className={`object-container`}>

                <div className={`prototype document-panel link `}>
                    <div className="flex-item">
                        <div className="document-header">
                            <div className={`link-title link complete`}>
                                <span className="title"
                                      dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_LINK_TITLE}}/>
                            </div>
                        </div>
                        <div className="link-sub-title" dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_LINK_SUB_TITLE}}/>

                        <div className="document-description"
                             dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_LINK_TEXT}}/>

                    </div>

                </div>
            </div>

        );
    }
}

PrototypeLink.propTypes = {
    locale: PropTypes.object,
};

PrototypeLink.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};

}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeLink);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeLink.js
 **/